import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const ReporteIndividualApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTrasladosReporte = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "traslados_reportes/individual",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const obtenerReporteExcel = async (params) => {
        setCargando(true);

        const query = new URLSearchParams(params).toString();

        const endpoint = `/api/traslados_reportes/individual-excel${query ? `?${query}` : ""}`;

        try {
            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                },
            });

            if (!response.ok) {
                // intentar obtener error real del backend
                let errorData;
                try {
                    errorData = await response.json();
                } catch (error) {
                    errorData = { detail: `Error HTTP ${response.status}` };
                }

                throw errorData;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "traslados.xlsx";
            a.click();
        } catch (error) {
            console.error("Error al obtener reporte Excel:", error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTrasladosReporte,
        obtenerReporteExcel,
        cargando,
    };
};
